export class ConsoleLogin {
    public userName: string;
    public password: string;
    public deskId: number;
}
